// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"527":"43fd8613","582":"43fd8613","5567":"c8588408","7827":"18411d69","8331":"43fd8613"}[chunkId] + ".css";
};